import {createSlice} from "@reduxjs/toolkit";

// Redux toolkit cho phép định nghĩa state (VD: "pageIsError"), định nghĩa các reducers/action (VD: setPageIsError)
// ngay trong 1 file JS, cho phép code dễ bảo trì hơn

// định nghĩa giá trị khởi tạo của state
// value=true tức là trang đang render có lỗi
// r/msg: thông tin chi tiết về lỗi
const initialState = {
    listChatTemplate: [],
    showTemplate: false,
    isLoadingChatTemplate: true,
    focusedIndex: 0,
    isReloadContactData: false
};

// định nghĩa state name, reducers, actions
const slice = createSlice({
    name: "chatTemplate",
    initialState,
    reducers: {
        // action public ra để dùng là: setPageIsError(true/false)
        setListChatTemplate: (state, action) => {
            state.listChatTemplate = action.payload;
        },
        setShowTemplate: (state, action) => {
            state.showTemplate = action.payload;
        },
        setIsLoadingChatTemplate: (state, action) => {
            state.isLoadingChatTemplate = action.payload;
        },
        setFocusedIndex: (state, action) => {
            state.focusedIndex = action.payload;
        },
        setIsReloadContactData: (state, action) => {
            state.isReloadContactData = action.payload;
        }
    }
});

// export state, actions, reducer để các components sử dụng
// lưu ý: quy định đặt tên giống như sample này để dễ hiểu, dễ bảo trì code
export const selectListChatTemplate = (state) => state.chatTemplate.listChatTemplate;
export const selectShowTemplate = (state) => state.chatTemplate.showTemplate;
export const selectIsLoadingChatTemplate = (state) => state.chatTemplate.isLoadingChatTemplate;
export const selectFocusedIndex = (state) => state.chatTemplate.focusedIndex;
export const selectIsReloadContactData = (state) => state.chatTemplate.isReloadContactData;
export const {
    setListChatTemplate,
    setShowTemplate,
    setIsLoadingChatTemplate,
    setFocusedIndex,
    setIsReloadContactData
} = slice.actions;
export default slice.reducer;
